module.exports = __webpack_public_path__ + "static/img/sx-ypt.6f12798.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/case/sx-ypt.png
// module id = VDGm
// module chunks = 1